// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React, { FC } from 'react';

import {
  StyledHeader,
  StyledLeftContent,
  StyledTitle,
  StyledLogo,
  StyledRightContent,
  StyledTestEnvTag
} from './Styled';
import LogoAthome from '../../icons/LogoAthome';

export const LiffHeader: FC = (props) => {
  return (
    <StyledHeader>
      <StyledLeftContent>
        <StyledLogo>
          <LogoAthome width="84" height="18" />
        </StyledLogo>
        <StyledTitle>LINEで問合せ</StyledTitle>
      </StyledLeftContent>

      <StyledRightContent>
        {process.env.NEXT_PUBLIC_MODE !== 'production' && (
          <StyledTestEnvTag>検証環境</StyledTestEnvTag>
        )}
      </StyledRightContent>
    </StyledHeader>
  );
};

LiffHeader.displayName = 'LiffHeader';

export default LiffHeader;
